var path = '/app-lite/grids/templates/cell.textarea.html';
var html = "<input class=\"form-control\"\n  data-ng-class=\"'colt' + col.index\"\n  data-ng-input=\"COL_FIELD\"\n  data-ng-model=\"COL_FIELD\"\n  editable-cell>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;